import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const ResiPropertyList = () => {
    const [resi_properties, setResiProperties] = useState([]);
    const [loading, setLoading] = useState(true); // Manage loading state

    useEffect(() => {
        // Fetch the residential property data from the API
        axios.get('/api/balance_sheet/assets/physical_assets/resi_properties/')
            .then(response => {
                console.log(response.data); // Log the response data for debugging
                setResiProperties(response.data); // Populate the component state
                setLoading(false); // Stop loading
            })
            .catch(error => {
                console.error('Error fetching residential property data:', error);
                setLoading(false); // Stop loading even on error
            });
    }, []); // Empty dependency array ensures this runs only on mount

    // Loading message while fetching data
    if (loading) {
        return <div>Loading residential properties...</div>;
    }

    const handleRemove = async (id) => {
        try {
            await axios.delete(`/api/balance_sheet/assets/physical_assets/resi_properties/${id}/`); // Call DELETE API
            // Update state to remove the deleted auto loan
            setResiProperties((prevResiProperty) => prevResiProperty.filter(resi_property => resi_property.id !== id));
            alert("Loan removed successfully");
        } catch (error) {
            console.error("Error removing loan:", error);
            alert("There was an error removing the loan.");
        }
    };

    // // Helper function to format currency
    // const formatCurrency = (amount) => {
    //     return `$${Math.round(amount).toLocaleString()}`;
    // };

    return (
        <div style={{ marginLeft: '40px' }}>
            <div style={{ margin: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h1 style={{ marginRight: '20px' }}>Residential Property List</h1>
                <div>
                    <Link style={{ marginRight: '10px' }} to="/balance_sheet/assets/physical_assets/">  Physical Assets</Link> |
                    <Link to="/assets/">  All Assets</Link>
                </div>
            </div>
                <Link to="/balance_sheet/assets/physical_assets/resi_properties/create-resi-property/">
                    <button type="button" className="btn btn-primary">Create New Residential Property</button>
                </Link>
            {/* Include other details as needed */}
            </div>

            <table className="resi-property-table">
                <thead>
                    <tr>
                        <th>Asset ID</th>
                        <th>Address</th>
                        <th>Purchase Price</th>
                        <th>Purchase Date</th>
                        <th>Livable Sq. Ft.</th>
                        <th>Financing</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {resi_properties.length > 0 ? (
                        resi_properties.map(resi_property => (
                            <tr key={resi_property.id}>
                                <td>
                                    <Link to={`/balance_sheet/assets/physical_assets/resi_properties/${resi_property.id}`}>{resi_property.id}</Link>
                                </td>
                                <td>{resi_property.address.street_address}, {resi_property.address.city}, {resi_property.address.state} {resi_property.address.postal_code} </td>
                                <td></td>
                                <td></td>
                                <td>{resi_property.square_footage_livable}</td>
                                <td></td>
                                <td>
                                    <button type="button" className="btn btn-danger" onClick={() => handleRemove(resi_property.id)}>Remove</button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>No residential properties found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style jsx>{`
                .resi-property-table {
                    margin: 20px;
                    width: 90%;
                    table-layout: auto;
                    border-collapse: collapse;
                }
                .resi-property-table th, .resi-property-table td {
                    border: 1px solid #ccc;
                    padding: 10px;
                    text-align: left;
                }
                .resi-property-table th {
                    background-color: #f0f0f0;
                }
                button {
                    background-color: #ff4d4d;
                    color: white;
                    border: none;
                    padding: 5px 10px;
                    cursor: pointer;
                }
                button:hover {
                    background-color: #ff0000;
                }
            `}</style>
        </div>
    );
};

export default ResiPropertyList;